export const QUEUE_VIEWS = {
    ACTIVE: "active",
    SAVED: "saved",
    LARGE_IMAGE: "largeImage"
};
